import React from "react";

export const StatisticsContext = React.createContext(null)
